// extracted by mini-css-extract-plugin
export default {"title":"_b2be5a72","container":"_462e9a35","copy":"_f2992477","searchTerm":"_f808feb2"};